const TITLE_KEY = "auria:v1:title-map";

function signatureOfTracks(tracks) {
  return (tracks || [])
    .map((track) => track?.id)
    .filter(Boolean)
    .join("|");
}

function readMap() {
  try {
    return JSON.parse(localStorage.getItem(TITLE_KEY) || "{}") || {};
  } catch {
    return {};
  }
}

function writeMap(map) {
  try {
    localStorage.setItem(TITLE_KEY, JSON.stringify(map));
  } catch {}
}

export function getTitleForSession(session) {
  if (session?.customTitle) return session.customTitle;
  const signature = signatureOfTracks(session?.arc?.tracks);
  if (!signature) return "Votre refuge";

  const map = readMap();
  if (map[signature]) return map[signature];

  const numbers = Object.values(map)
    .map((value) => /^Refuge (\d+)$/.exec(value)?.[1])
    .filter(Boolean)
    .map(Number);
  const next = numbers.length ? Math.max(...numbers) + 1 : 1;
  const title = `Refuge ${String(next).padStart(2, "0")}`;
  map[signature] = title;
  writeMap(map);
  return title;
}

export function setCustomTitleForSession(session, title) {
  const signature = signatureOfTracks(session?.arc?.tracks);
  if (!signature) return;
  const map = readMap();
  const clean = String(title || "").trim().slice(0, 40);
  if (clean) map[signature] = clean;
  else delete map[signature];
  writeMap(map);
}

export function clearCustomTitleForSession(session) {
  setCustomTitleForSession(session, "");
}

const NARRATIVES = Object.freeze({
  relax: [
    "Quelques minutes pour faire baisser la tension et relâcher le corps.",
    "Une respiration régulière pour retrouver un rythme plus calme.",
    "Cette séance vous aide à ralentir et à réduire la pression ressentie.",
  ],
  rest: [
    "Un moment pour réduire le rythme et préparer le corps au repos.",
    "Vous pouvez simplement respirer, sans objectif de performance.",
    "Cette séance facilite la transition vers un état plus calme.",
  ],
  recenter: [
    "Quelques minutes pour rassembler votre attention sans la brusquer.",
    "Une respiration structurée pour stabiliser votre attention.",
    "Cette séance aide à réduire la dispersion et à retrouver plus de clarté.",
  ],
});

export function generateNarrative({ intent, seed = 0 }) {
  const list = NARRATIVES[intent] || NARRATIVES.relax;
  return list[Math.abs(seed) % list.length];
}
